import { useDidMount } from '@surveycake/rhooks';
//	@ts-ignore
import load from 'load-script';
import { useState } from 'react';

const loadYoutubeIframeApi = () =>
  new Promise(resolve => {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve();
    } else {
      const protocol =
        window.location.protocol === 'http:' ? 'http:' : 'https:';
      load(`${protocol}//www.youtube.com/iframe_api`);

      //	@ts-ignore
      const previous = window.onYouTubeIframeAPIReady;

      //	@ts-ignore
      window.onYouTubeIframeAPIReady = () => {
        if (previous) {
          previous();
        }

        resolve();
      };
    }
  });

export function useLoadYoutubeIframeApi() {
  const [apiFulfilled, setApiFulfilled] = useState(false);

  useDidMount(async () => {
    try {
      await loadYoutubeIframeApi();
      setApiFulfilled(true);
    } catch (error) {
      setApiFulfilled(false);
    }
  });

  return apiFulfilled;
}
